module.exports = () => {
    import('./element');
    import('wolfuix/js/polyfill/ArrayPolyfill');
    import('wolfuix/js/polyfill/StringPolyfill');
};
